import { ISendEmailProjetoImpressaoUseCase } from "../../../presentation/useCases/read/send_email_projeto_impressao_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * SendEmailProjetoImpressaoUseCase
 */

export class SendEmailProjetoImpressaoUseCase implements ISendEmailProjetoImpressaoUseCase {
  constructor(private readonly repository: IProjetosRepository) { }

  async execute(
    idProjetoImpressao: number,
    subject: string,
    sendTo: string,
    body: string,
    attachment: string,
  ): Promise<void> {
    const emails = sendTo.split(';');
    emails.forEach(e => e.trim());

    await this.repository.sendEmailProjetoImpressao(
      idProjetoImpressao,
      subject,
      emails,
      body,
      attachment,

    );

  }
}
